type SendIconProps = {
  className?: string;
};

export default function SendIcon({ className }: SendIconProps) {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M16.2 1.8 8.4 9.6M16.2 1.8l-4.5 14.4L8.4 9.6m7.8-7.8L1.8 7.5l6.6 2.1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
